import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Button, HistoryLog, Pager } from 'arag-ui-lib';
import moment from "moment";
import CONTENT_STRINGS from '../helpers/contentStrings';
import { getOverviewCommentTitle } from "../helpers/policy/function";
import { SECONDARY_VARIANT_STYLE, FORM_GROUP_VARIANTS } from '../helpers/formGroupVariants';
import { PRIMARY, RIGHT, QUATERNARY } from '../helpers/constants';
import { SOLICITOR_USERS } from '../helpers/variables';
import { parseCommentWithNewLines } from '../helpers/commentParser';

const OverviewTabFilterList = (props) => {
    const {
        overviewData,
        UserRole,
        commentRefs,
        pagerProps,
        // Filter props
        filterOptions,
        onFilterChange,
        onCheckboxChange,
        filterValue,
        includeNoChanges,
        onFilterApply,
        onFilterReset
    } = props;
    return(
        <div>
            { 
                !SOLICITOR_USERS.includes(UserRole) ?
                    <div className='form-group'>
                        <div>
                            <FormGroup
                                labelSize='col-sm-3'
                                inputSize='col-sm-6'
                                name='overviewfilterBy'
                                label={CONTENT_STRINGS.FILTER_BY_VISIBILITY}
                                variant={FORM_GROUP_VARIANTS.SELECT}
                                inputProps={{
                                    options: filterOptions,
                                    onChange: onFilterChange,
                                    name: 'overviewfilterBy',
                                    id: 'overviewfilterBy',
                                    value: filterValue,
                                }}
                                requiredStyle={SECONDARY_VARIANT_STYLE}
                                formGroupTestId={'overview-comments-visibility-filter'}
                            />
                            <div className='col-sm-12'>
                            <div className='col-sm-3'></div>
                            <div className='custom-reverse-checkbox'>
                                <FormGroup
                                    labelSize='col-sm-4 custom-label'
                                    inputSize='col-sm-1'
                                    label={CONTENT_STRINGS.FILTER_INCLUDE_NO_CHANGES}
                                    variant={FORM_GROUP_VARIANTS.CHECKBOX}
                                    inputProps={{
                                        name: 'includeNoChanges',
                                        id: 'includeNoChanges',
                                        checked: includeNoChanges,
                                        onChange: onCheckboxChange,
                                    }}
                                    groupShape={'reverse'}
                                    formGroupTestId={'overview-comments-include-no-changes-filter'}
                                />
                            </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-xs-offset-3  col-sm-6' style={{ display: 'flex', gap: 10 }}>
                                <Button
                                    variant={PRIMARY}
                                    label={CONTENT_STRINGS.FILTER_LABEL}
                                    arrowDirection={RIGHT}
                                    onClick={onFilterApply}
                                    buttonTestId={'overview-comments-apply-filter'}
                                />
                                <Button
                                    variant={QUATERNARY}
                                    label={CONTENT_STRINGS.CLEAR_FILTERS_LABEL}
                                    arrowDirection={RIGHT}
                                    onClick={onFilterReset}
                                    buttonTestId={'overview-comments-clear-filter'}
                                />
                            </div>
                        </div>
                    </div>
                : null
            }
            <div className='row'>
                {overviewData.map((item, index) => {
                    let commentVisibilityText = '';
                    if (!SOLICITOR_USERS.includes(UserRole)) {
                        if (item.visibleByMedical && item.visibleBySolicitor) {
                            commentVisibilityText = CONTENT_STRINGS.VISIBLE_TO_ALL;
                        } else if (item.visibleByMedical) {
                            commentVisibilityText = CONTENT_STRINGS.VISIBLE_TO_ARAG_AND_MEDICAL_EXPERT;
                        } else {
                            commentVisibilityText = CONTENT_STRINGS.VISIBLE_TO_ARAG;
                        }
                    }
                    return (
                        <div key={item.id} ref={el => commentRefs.current[item.id] = el}>
                            <HistoryLog
                                createdDate={moment(item.created).format('DD/MM/YYYY - HH:mm:ss')}
                                createdBy={item.fullName}
                                title={getOverviewCommentTitle(item)}
                                subtitle={commentVisibilityText}
                                log={parseCommentWithNewLines(item.comment)}
                                attachments={item.attachments}
                                historyLogTestId={`overview-history-${index}`}
                                readMoreTestId={'overview-history-read-more'}
                                readLessTestId={'overview-history-read-less'}
                                leftColumnSizeId={'overview-history-content'}
                                creatorTestId={'overview-history-username'}
                                timestampTestId={'overview-history-timestamp'}
                                subtitleTestId={'overview-history-visibility'}
                                rightColumnSizeId={'overview-history-content'}
                            />
                        </div>
                    );
                })}
                <div className={'row col-sm-12'}>
                    <Pager {...pagerProps} />
                </div>
            </div>
        </div>
    )
};

OverviewTabFilterList.propTypes = {
    overviewData: PropTypes.array.isRequired,
    UserRole: PropTypes.string.isRequired,
    commentRefs: PropTypes.object.isRequired,
    pagerProps: PropTypes.object.isRequired,
    filterOptions: PropTypes.array.isRequired,
    filterValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onFilterChange: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    onFilterApply: PropTypes.func.isRequired,
    onFilterReset: PropTypes.func.isRequired,
};

export default OverviewTabFilterList;